import URI from 'jsuri';
import Q from 'q';

import type { ActionContext } from 'js/lib/ActionContext';
import API from 'js/lib/api';

import CourseReferencesStore from 'bundles/course-home/page-course-references/stores/CourseReferencesStore';

export default (actionContext: ActionContext, courseId: string): Q.Promise<any> => {
  if (actionContext.getStore(CourseReferencesStore).hasLoaded()) {
    return Q();
  }

  const api = API('/api/onDemandReferences.v1', { type: 'rest' });

  const uri = new URI()
    .addQueryParam('courseId', courseId)
    .addQueryParam('q', 'courseListed')
    .addQueryParam('fields', 'name,shortId,slug,content')
    .addQueryParam('includes', 'assets');

  return Q(api.get(uri.toString()))
    .then((response) => {
      actionContext.dispatch('LOAD_REFERENCES_LIST', response.elements);
    })
    .catch((error) => {
      actionContext.dispatch('REFERENCE_LIST_LOAD_FAILURE', error);
    });
};
